import { toastr } from 'react-redux-toastr';
import Logger from 'logger';

export const HANDLE_CONNECTION_EXCEPTION = 'HANDLE_CONNECTION_EXCEPTION';

const connectionException = {
  code: 0,
  title: 'Network error',
  message: 'Something went wrong during sending request to the server. Please check your internet connection or try again later.'
};

function requestHandleConnectionException() {
  return {
    type: HANDLE_CONNECTION_EXCEPTION,
    code: 0,
    message: connectionException.message
  };
}

export function handleConnectionException(exception, callbackActionCreator, showNetworkErrorAlert) {
  connectionException.error = { message: exception.errorMessage ?? connectionException.title };
  console.error('Network exception', exception);
  Logger.error({
    message: connectionException.title,
    request: {
      method: exception.config && exception.config.method,
      URL: exception.config && exception.config.url
    },
    type: 'NETWORK'
  });

  return (dispatch) => {
    if (showNetworkErrorAlert) {
      toastr.error(connectionException.title, connectionException.message);
    }
    if (callbackActionCreator && typeof callbackActionCreator === 'function') {
      return dispatch(callbackActionCreator(connectionException));
    }
    return dispatch(requestHandleConnectionException());
  };
}
